import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../LandingPage/Footer";
import useBlogs from "../../services/LandingPage/useBlogs";
import author from "../../images/LandingPageImage/Author_img.svg";
import Navbar from "./Navbar";

const Blogs = () => {
  const { blogs, fetchAllBlogs, loading } = useBlogs();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const blogsPerPage = 12;

  const filteredBlogs = (blogs || []).filter(
    (blog) =>
      blog.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      blog.description?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);
  const indexOfLast = currentPage * blogsPerPage;
  const indexOfFirst = indexOfLast - blogsPerPage;
  const currentBlogs = filteredBlogs.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    if (fetchAllBlogs) {
      fetchAllBlogs();
    }
  }, [fetchAllBlogs]);

  return (
    <>
      |<Navbar />
      <div className="min-h-screen bg-gray-50 py-10">
        <div className="max-w-6xl mx-auto px-4">
          <h1 className="text-3xl font-semibold text-center mb-8 text-gray-800">
            Get Insightful Views About WhatsApp Business
          </h1>

          {/* Search */}
          <div className="flex justify-center mb-10">
            <input
              type="text"
              placeholder="Search blogs..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full md:w-1/2 px-4 py-3 border rounded-3xl focus:ring-2 focus:ring-green-500 outline-none"
            />
          </div>

          {/* Blog Grid */}
          {loading ? (
            <div className="text-center">Loading blogs...</div>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
              {currentBlogs.map((blog) => (
                <div
                  key={blog.id}
                  className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition flex flex-col"
                >
                  {/* Image */}
                  <div className="w-full h-35 overflow-hidden">
                    <img
                      src={blog.image}
                      alt={blog.title}
                      className="w-full h-full object-cover"
                    />
                  </div>

                  {/* Content */}
                  <div className="p-6 flex flex-col flex-grow">
                    <div>
                      <div className="flex items-center gap-2 mb-3 text-sm text-gray-500">
                        <img src={author} alt="" className="w-4" />
                        {blog.author}
                      </div>

                      <h3 className="text-lg font-semibold mb-3 line-clamp-2">
                        <Link
                          to={`/blogs/${blog.post_slug}`}
                          className="hover:text-green-600 transition"
                        >
                          {blog.title}
                        </Link>
                      </h3>

                      <p className="text-gray-600 text-sm line-clamp-3">
                        {blog.description}
                      </p>
                    </div>

                    {/* Push button to bottom */}
                    <Link
                      to={`/blogs/${blog.post_slug}`}
                      onClick={() => {}}
                      className="text-green-600 font-medium mt-auto pt-4"
                    >
                      Read more →
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Pagination */}
          <div className="flex justify-center gap-2 mt-12">
            <button
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
              className="px-4 py-2 border rounded-lg disabled:opacity-50"
            >
              Previous
            </button>

            {Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index}
                onClick={() => setCurrentPage(index + 1)}
                className={`px-4 py-2 rounded-lg ${
                  currentPage === index + 1
                    ? "bg-green-600 text-white"
                    : "border"
                }`}
              >
                {index + 1}
              </button>
            ))}

            <button
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="px-4 py-2 border rounded-lg disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blogs;
